import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { TourProvider } from '@reactour/tour';
import { persistor, store } from './store/store';
import { reactTourSteps, reactTourStyles } from './utils/react-tour.util';

import App from './app/app';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <BrowserRouter>
                <TourProvider
                    steps={reactTourSteps}
                    styles={reactTourStyles}
                    onClickMask={() => {}}
                    scrollSmooth
                    showDots={false}
                    showPrevNextButtons={true}
                    showNavigation={true}
                >
                    <App />
                </TourProvider>
            </BrowserRouter>
        </PersistGate>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();